<template>
  <v-list class="pt-1">
    <v-list-tile avatar tag="div" v-for="user in users" :key="user.uid" :class="{'is_active' : isActive(user)}" @click.prevent="changeChannel(user)">
      <v-list-tile-avatar>
        <img :src="user.avatar" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title><span class="smaller__icon"><v-icon :class="{'success--text': isOnline(user), 'red--text': !isOnline(user)}">radio_button_checked</v-icon></span> {{ user.name }} <v-chip class="green lighten-2" v-if="getNotification(user) >= 1">{{ getNotification(user) }}</v-chip>
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '../mixins'
import firebase from 'firebase'

export default {
  name: 'users',
  data () {
    return {
      users: [],
      usersRef: firebase.database().ref('users'),
      connectedRef: firebase.database().ref('.info/connected'),
      presenceRef: firebase.database().ref('presence'),
      privateMessagesRef: firebase.database().ref('privateMessages'),
      notifCount: [],
      channel: null
    }
  },
  mixins: [mixin],
  computed: {
    ...mapGetters(['currentUser', 'currentChannel', 'isPrivate'])
  },
  watch: {
    isPrivate () {
      if (!this.isPrivate) {
        this.resetNotifications()
      }
    }
  },
  mounted () {
    this.addListeners()
  },
  methods: {
    addListeners () {
      this.usersRef.on('child_added', snap => {
        if (this.currentUser.uid !== snap.key) {
          let user = snap.val()
          user['uid'] = snap.key
          user['status'] = 'offline'
          this.users.push(user)
        }
      })

      this.presenceRef.on('child_added', snap => {
        if (this.currentUser.uid !== snap.key) {
          this.addStatusToUser(snap.key)
          let channelId = this.getChannelId(snap.key)

          this.privateMessagesRef.child(channelId).on('value', snap => {
            this.handleNotifications(
              channelId,
              this.currentChannel.id,
              this.notifCount,
              snap
            )
          })
        }
      })

      this.presenceRef.on('child_removed', snap => {
        if (this.currentUser.uid !== snap.key) {
          this.addStatusToUser(snap.key, false)

          this.privateMessagesRef.child(this.getChannelId(snap.key)).off()
        }
      })

      this.connectedRef.on('value', snap => {
        if (snap.val() === true) {
          let ref = this.presenceRef.child(this.currentUser.uid)
          ref.set(true)
          ref.onDisconnect().remove(err => {
            if (err !== null) console.log(err)
          })
        }
      })
    },
    addStatusToUser (userId, connected = true) {
      let index = this.users.findIndex(user => user.uid === userId)
      if (index !== -1) {
        connected === true
          ? (this.users[index].status = 'online')
          : (this.users[index].status = 'offline')
      }
    },
    isOnline (user) {
      return user.status === 'online'
    },
    changeChannel (user) {
      if (this.channel === null) {
        this.resetNotifications(user)
      } else {
        this.resetNotifications()
      }

      let channelId = this.getChannelId(user.uid)
      let channel = { id: channelId, name: user.name }

      this.channel = channel
      this.$store.dispatch('setPrivate', true)
      this.$store.dispatch('setCurrentChannel', channel)
    },
    isActive (user) {
      let channelId = this.getChannelId(user.uid)
      return this.currentChannel.id === channelId
    },
    getChannelId (userId) {
      return userId < this.currentUser.uid
        ? userId + '/' + this.currentUser.uid
        : this.currentUser.uid + '/' + userId
    },
    getNotification (user) {
      console.log(user)
      let channelId = this.getChannelId(user.uid)
      let notif = 0

      this.notifCount.forEach(el => {
        if (el.id === channelId) {
          notif = el.notif
        }
      })
      return notif
    },
    resetNotifications (user = null) {
      let channelId = null
      if (user !== null) {
        channelId = this.getChannelId(user.uid)
      } else {
        channelId = this.channel.id
      }

      let index = this.notifCount.findIndex(el => el.id === channelId)
      if (index !== -1) {
        this.notifCount[index].total = this.notifCount[index].lastKnownTotal
        this.notifCount[index].notif = 0
      }
    },
    detachListeners () {
      this.usersRef.off()
      this.presenceRef.off()
      this.connectedRef.off()
    }
  },
  beforeDestroy () {
    this.detachListeners()
  }
}

</script>

<style lang="stylus">
.smaller__icon .icon,
.smaller__icon .material-icons
  font-size: 10px !important
</style>



// WEBPACK FOOTER //
// Users.vue?8f7fa438